import { EntityInput, LinkProps } from "helpers/url";

export function searchHref(
  entity: EntityInput,
  region?: string
): LinkProps["href"] {
  const obj = {
    pathname: "/search",
    query: {
      what: entity.alias,
    },
  };

  if (region) {
    obj.query["region"] = region;
  }
  return obj;
}

export function searchAs(
  entity: EntityInput,
  region?: string
): LinkProps["as"] {
  return {
    pathname: `/search/${region ? `r_${region}/` : ""}`,
    query: {
      what: entity.alias,
    },
  };
}
